export enum BrandEnum {
    Titanium = 1,
    Precious = 2,
    TitaniumAndPrecious = Titanium | Precious
}
export const BrandConstants = {
    PRECIOUS: "precious",
    TITANIUM: "titanium"
}